import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardSensor, PointerSensor } from '@dnd-kit/react';
import { useSortable } from '@dnd-kit/react/sortable';
import classNames from 'classnames';

import ListContainer from '../../../containers/ListContainer';
import styles from '../Board.module.scss';

function SortableList({ id, index, canEdit }) {
  console.log('SORTABLE LIST', {
    id,
    index,
    canEdit,
  });
  const sortable = useSortable({
    id,
    index,
    group: 'lists',
    type: 'List',
    accept: ['List'],
    disabled: !canEdit,
    sensors: [KeyboardSensor, PointerSensor],
  });

  console.log('SORTABLE', {
    id,
    disabled: sortable.sortable?.draggable?.disabled,
    isDragging: sortable.isDragging,
  });
  return (
    <div
      ref={(el) => {
        console.log('LIST REF', id, el);

        sortable.ref(el);
      }}
      className={classNames(
        styles.list,
        canEdit ? styles.draggable : '',
        sortable.isDragging ? styles.dragging : '',
      )}
    >
      <ListContainer id={id} />
    </div>
  );
}

SortableList.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default React.memo(SortableList);
